import * as React from 'react';

import type { IconProps } from '../../types';

/**
 * Handshake icon
 *
 * @category Business
 */
const Handshake = React.forwardRef<SVGSVGElement, IconProps>(
  ({ 'data-testid': testId, size = 20, className, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        data-testid={testId}
        width={size}
        height={size}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        role="img"
        aria-hidden="true"
        {...props}
      >
        <path
          fill="currentColor"
          d="M16.332 24.541c-2.036-2.035-4.324-4.335-6.302-6.302-1.795-1.794-5.624-5.635-6.28-6.28-.23-.195-.552-.264-.816 0-.414.541-.023.794.39 1.231l.817.817c1.334 1.391 4.842 4.715 5.532 5.612-.253.495-1.058 1.081-1.45 1.576-.69.667.093 1.518.806.805.586-.357 1.38-2.001 2.093-.978.138.184.172.357.034.564-.356.62-1.966 1.426-1.368 2.23.805.61 1.656-1.069 2.231-1.368.242-.195.472-.069.69.138.207.207.334.437.138.69-.333.46-1.184 1.081-1.46 1.633-.093.219-.058.449.103.598.805.61 1.656-1.058 2.231-1.368.391-.368 1.254.552 1.116.908-.184.552-1.61 1.242-1.288 2.001.69.943 1.656-.862 2.208-1.08.172-.081.333.022.563.24.403.357.828.92 1.288 1.15a.52.52 0 0 0 .598-.091c.76-.644-1.69-2.335-1.828-2.657l-.058-.057zm3.783-6.693c-1.713.299.357 1.863.943 2.496.852.782 1.323 1.495 2.036 1.874.736.242.989-.667.471-1.104-.908-.862-2.403-2.518-3.323-3.22l-.127-.034zm-1.655 1.668c-1.714.299.356 1.863.942 2.495.851.782 1.323 1.495 2.036 1.875.736.241.989-.667.472-1.104-.909-.863-2.404-2.519-3.324-3.22l-.127-.035zm-1.657 1.656c-1.874.356.736 2.15 1.346 2.886.793.725 1.07 1.311 1.817 1.518a.53.53 0 0 0 .552-.333c.103-.84-.679-1.116-1.22-1.783-.678-.62-1.759-1.851-2.357-2.242l-.126-.035z"
        />
        <path
          fill="currentColor"
          d="M29.178 11.937c-1.081-.104-1.702 1.046-2.83 2.058-1.104 1.104-2.219 2.358-2.874 2.83-.38.264-.782.31-1.197.011-1.127-.84-2.3-2.335-3.38-3.255-1.185-1.08-1.68-1.07-2.818-.011-.978.805-2.082 2.473-3.37 2.61-1.07-.505.61-1.76 1.978-3.231 1.898-1.944 4.566-4.67 6.118-6.256.61-.69 1.714-1.541 1.104-2.105-.862-.057-1.46.77-2.553 1.829-1.15 1.15-2.403 2.541-3.082 3.047-.69.495-1.08.207-1.886-.563-.943-.909-2.369-2.496-3.37-3.358-.586-.564-1.747-.955-1.207.172.506 1.081 3.209 3.37 4.117 4.589.3.414.403.874.127 1.334-.69 1.15-2.208 2.22-2.726 3.45-.678 1.368.518 2.932 1.955 2.461 1.127-.368 2.14-1.656 3.048-2.461.54-.506 1.207-.874 1.863-.38 2.081 1.61 4.082 4.486 6.198 5.912 1.737.862-.08-1.472-.034-2.117.264-1.575 1.92-2.415 3.07-3.83.91-1.069 1.91-1.62 1.806-2.679l-.046-.046z"
        />
      </svg>
    );
  }
);

Handshake.displayName = 'Handshake';

export { Handshake };
